import { useBackendPaginatedQuery } from '../useBackendPaginatedQuery'
import { useBackendQuery } from '../useBackendQuery'

export interface UseStoresQueryProps {
  page?: number
  itemsPerPage?: number
  lat?: number
  lng?: number
}

export function useStoresQuery<Store>(options: UseStoresQueryProps = {}) {
  const { page = 1, itemsPerPage = 10, lat, lng } = options

  const params = { page, limit: itemsPerPage, lat, lng }

  const query = useBackendQuery<Store>(['/stores/all', { params }])

  return query
}

export default useStoresQuery
